import React from 'react';
import classnames from 'classnames';

const statuses = {
    INITIAL: 'initial',
    LOADING: 'loading',
    SUCCESS: 'success',
    FAILURE: 'failure'
};

const imagUploadUrl = 'https://0e0qzhfzzk.execute-api.us-west-2.amazonaws.com/prod/upload';

class ImageUploadWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: statuses.INITIAL
        };
    }

    postImageUploadRequest = (postData) => {
        this.setState((state) => ({
            ...state,
            status: statuses.LOADING
        }));
        const request = new XMLHttpRequest();
        request.onload = () => {
            const response = JSON.parse(request.responseText);
            if (request.status >= 200 && request.status < 300 && !response.error) {
                this.setState((state) => ({
                    ...state,
                    status: statuses.SUCCESS
                }));
                const value = response.imageUrl;
                this.props.onChange({
                    target: {
                        value,
                        checkValidity: () => true
                    }
                });
            } else {
                this.setState((state) => ({
                    ...state,
                    status: statuses.FAILURE
                }));
            }
        };
        request.open('POST', imagUploadUrl, true);
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
        request.send(JSON.stringify(postData));
    }

    handleImageUpload = ({
        target: {
            files: [image]
        }
    }) => {
        const reader = new FileReader();
        reader.addEventListener(
            'load',
            () => {
                const content = reader.result.split('base64,')[1];
                const fileName = image.name;
                const mimeType = image.type;
                this.postImageUploadRequest({
                    content,
                    fileName,
                    mimeType
                });
            },
            false
        );
        reader.addEventListener('loadstart', () => {
            this.setState((state) => ({ ...state, status: statuses.LOADING, statusMessage: '' }));
        });
        if (image) {
            reader.readAsDataURL(image);
        }
    }

    render() {
        const { status } = this.state;
        const { imageUrl, isValid } = this.props;
        const isLoading = status === statuses.LOADING;
        const isSuccess = status === statuses.SUCCESS;
        const isError = status === statuses.FAILURE;
        const className = classnames({
            'image-upload-widget': true,
            'image-upload-widget--invalid': !isValid
        });
        return (
            <div className={className}>
                {!isLoading &&
                    <label className="image-upload-widget__label">
                        <span className="fa fa-upload" />
                        <span className="image-upload-widget__label-text">Upload Image</span>
                        <input
                            className="image-upload-widget__input"
                            onChange={this.handleImageUpload}
                            type="file"
                            accept="image/*"
                        />
                    </label>
                }
                {(imageUrl && !isLoading) &&
                    <img
                        className="image-upload-widget__image"
                        src={imageUrl}
                        alt=""
                    />
                }
                {isLoading &&
                    <span className="image-upload-widget__status-text image-upload-widget--loading">
                        Uploading...
                    </span>
                }
                {isSuccess &&
                    <span className="image-upload-widget__status-text image-upload-widget--upload">
                        Image upload success
                    </span>
                }
                {isError &&
                    <span className="image-upload-widget__status-text image-upload-widget--failed">
                        Image upload failed
                    </span>
                }
            </div>
        );
    }
}

export default ImageUploadWidget;



// WEBPACK FOOTER //
// ./components/image_upload_widget/index.jsx